const math = {
  randomRange: (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1) + min),
  toPercentage(value: number, total: number): number {
    return Math.round((value * 100) / total) / 100;
  },
  clamp: (value: number, min: number, max: number): number => {
    return Math.max(Math.min(value, max), min);
  },
  clampToBounds: (value: number, min: number, max: number): number => {
    if (value > max) {
      return min;
    }

    if (value < min) {
      return max;
    }

    return value;
  },
};

export default math;
